











import Vue from 'vue';
import Component from 'vue-class-component';
import AeIcon from '../../index';

Vue.use(AeIcon);

@Component({
  name: 'Demo1'
})
export default class Demo1 extends Vue {
}
